import qc from 'qc'
import { LayoutStyle } from './types'

export type ClipboardType = {
  // 复制的节点
  nodes?: qc.Node[];
  // event、animation、style、response-event 数据来源节点
  originalNode?: qc.Node;
  event?: any;
  animation?: any;
  style?: any;
  responseEvent?: any;
  positionAndSize?: LayoutStyle | null;
}
let clipboard: ClipboardType = {}

export function emptyClipboard(): void {
  clipboard = {}
}

export function getClipboard(): ClipboardType {
  return clipboard
}

export function setClipboard(val: ClipboardType): void {
  clipboard = val
}
